export enum FileFormat {
    CSV = 0,
    Excel = 1,
    PDF = 2,
}